import { useMemo } from 'react';
import inputMap from './FilterList';
import { useDispatch, useSelector } from 'umi';
import { LANGUAGE_EN, POE_DEMO_GAME_CODE_LIST } from '@/pages/dashboard/_config/constant';
import renderCustom from './RenderCustomSelect';
import { REGION, CATEGORY } from './_config';
import { ISelectorState } from '@/pages/dashboard/types/dashboard';

interface UseInputPropType {
  gameCode: string;
  value: any;
  defaultValue: any;
  internalValue: any;
  inputList: Array<any>;
  latestDate: any;
  curValue: any;
  isReseted: boolean;
  onFilterChange: (key: string, value: any, viewType: string) => void;
  locale: string;
  getLocalText: (id: string, params?: any, fallback?: boolean) => string;
  overRangeTimeLimit: boolean;
}


export default (props: UseInputPropType) => {
  const { value, defaultValue, curValue, internalValue, inputList = [], latestDate, onFilterChange, locale, getLocalText, isReseted, gameCode, overRangeTimeLimit } = props;
  const dispatch = useDispatch();
  const gameConfig = useSelector(state =>
    // @ts-ignore
    state?.dashboardSetting?.gameConfig || {}
  );
  const dataFrame = useSelector((state: ISelectorState) => state?.dashboard?.currentGame?.data_frame || '');
  
  const renderInput = useMemo(() => inputList.map((item: any) => {
    const { 
      type, key, render: itemRender, visible, 
      name_en, name_cn,
      all_info_en, all_info_cn,
      radioOptions,  // 前端字段（已映射或原有）
      // 映射后的字段（如果存在）
      lftName,
      rtName,
      parentChildName,
      parentKey,
      childKey,
      allInfo,
      ...rest 
    } = item;
    
    const inputVal = curValue[key] || null;
    const inputDefaultVal = defaultValue[key] || null;
    const inputType = type || key;

    // is_custom===1 时（如 bundle 标为自定义）走 RenderCustomSelect，否则按 key 映射内置 render
    // @ts-ignore
    const render = item?.is_custom === '1' ? renderCustom : (itemRender || inputMap[inputType] || renderCustom);
    const renderFlag = !render || visible === 2 || visible === 0;
    if (renderFlag) {
      return null;
    }
    const isPoeDemo = POE_DEMO_GAME_CODE_LIST?.includes(gameCode);
    const isRegisterFunnel = window?.location.href?.includes('funnel/registerFunnel');
    const isPoeFunnel = isPoeDemo && isRegisterFunnel;
    const isCasual = dataFrame === 'casual';
    const isEn = locale === LANGUAGE_EN;
    
    const name = (isEn && name_en) ? name_en : name_cn;
    
    return render({
      ...rest,
      key,
      locale,
      gameCode,
      isPoeFunnel,
      isCasual,
      getLocalText,
      latestDate,
      value: inputVal,
      defaultValue: inputDefaultVal,
      onChange: (key: string, val: any) => onFilterChange(key, val, item?.view_type),
      isReseted,
      dispatch,
      seasonInfo: gameConfig?.season_info,
      name,
      allInfo: allInfo || (isEn ? all_info_en : all_info_cn),
      lftName,
      rtName,
      parentChildName,
      parentKey,
      childKey,
      radioOptions,
      renderKey: `select_${key}`,
      overRangeTimeLimit,
    });

  }), [value, internalValue, inputList, gameConfig, dataFrame, latestDate, locale, getLocalText]);

  return {
    renderInput
  };
};
